import Cookies from 'js-cookie';

export class Auth {
    static authenticate()
    {
        // noinspection JSUnresolvedFunction
        Cookies.set('authenticated', 'true', {sameSite: 'lax'});
    }

    static verify(verified)
    {
        // noinspection JSUnresolvedFunction
        Cookies.set('verified', verified ? 'true' : 'false', {sameSite: 'lax'});
    }

    static clear()
    {
        // noinspection JSUnresolvedFunction
        Cookies.remove('authenticated', {sameSite: 'lax'});
        // noinspection JSUnresolvedFunction
        Cookies.remove('verified', {sameSite: 'lax'});
        // noinspection JSUnresolvedFunction
        Cookies.remove('isAdministrator', {sameSite: 'lax'});
    }

    static redirectToLogin()
    {
        location.href = "/login";
    }

    static actAsAdministrator()
    {
        // noinspection JSUnresolvedFunction
        Cookies.set('isAdministrator', 'true', {sameSite: 'lax'});
    }

    static isAdministrator()
    {
        // noinspection JSUnresolvedFunction
        return Cookies.get('isAdministrator') === 'true';
    }
}

export class Paths {
    static pdfOffer(draftId)
    {
        return "/drafts/"+draftId+"/offer/pdf";
    }
}

export class Locale {
    static saveToCookie(locale)
    {
        // noinspection JSUnresolvedFunction
        Cookies.set('locale', locale, {sameSite: 'lax'});
    }

    static getFromCookie()
    {
        // noinspection JSUnresolvedFunction
        return Cookies.get('locale');
    }

    static setDateTimeFormat(locale)
    {
        window.dateTimeFormatHourMinute = new Intl.DateTimeFormat(locale, {timeStyle: 'short'});
        window.dateTimeFormatDayMonth = new Intl.DateTimeFormat(locale, {month: 'short', day: '2-digit'});
        window.dateTimeFormat = new Intl.DateTimeFormat(locale, {dateStyle: 'short'});
    }

    static setCurrencyNumberFormat(locale)
    {
        window.currencyNumberFormat = new Intl.NumberFormat(locale, { style: 'currency', currency: 'PLN', currencyDisplay: 'code' });
    }
}
